import React  from 'react';
import Routes from './Router'

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
